export default __webpack_public_path__ + "static/media/amazonwatch.654c2a18.png";